<template>
  <div>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newPolType">mdi-plus</v-icon>
          <v-icon v-else-if="!modePolType">mdi-pencil</v-icon>
          <v-icon v-else-if="modePolType">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newPolType">Create New Policy Type</v-toolbar-title>
          <v-toolbar-title v-else-if="!modePolType">Edit Policy Type</v-toolbar-title>
          <v-toolbar-title v-else-if="modePolType">Query Policy Type</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="!newPolType" color="primary" @click="doBusCls()">
              Permitted Business Class
            <v-icon right>mdi-view-list</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newPolType">
                <v-text-field v-model="polTypeForm.polType" :label="labels.polType" :error-messages="errors.collect('polType')" data-vv-name="polType" :data-vv-as="labels.polType" v-validate="'required|max:4'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.polType}}</v-subheader>
                <div class="queryValue">{{polTypeForm.polType}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field :readonly="modePolType" v-model="polTypeForm.polTypeDesc" :label="labels.polTypeDesc" :error-messages="errors.collect('polTypeDesc')" data-vv-name="polTypeDesc" :data-vv-as="labels.polTypeDesc" v-validate="'required|max:40'"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
              <div>
                <v-icon>mdi-newspaper</v-icon><span class="headerTitle">{{labels.general}}</span>
              </div>
          </v-expansion-panel-header>
            <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-text-field v-model="polTypeForm.polNoForm" :label="labels.polNoForm" :error-messages="errors.collect('polNoForm')" data-vv-name="polNoForm" :data-vv-as="labels.polNoForm" v-validate="'required|numeric|max:2'" append-icon="mdi-magnify" @input="doPolNoForm($event)" @click:append="getHelpList('polNoForm')" :hint="polNoFormDesc" persistent-hint></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field :readonly="modePolType" v-model="polTypeForm.expiryTime" :label="labels.expiryTime" :error-messages="errors.collect('expiryTime')" data-vv-name="expiryTime" :data-vv-as="labels.expiryTime" v-validate="'numeric|max:4|between:0,2400'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-autocomplete :items="departments" v-model="polTypeForm.dept" :label="labels.dept" item-text="label" item-value="value" :error-messages="errors.collect('dept')" data-vv-name="dept" :data-vv-as="labels.dept" v-validate="'required'" :clearable="!modePolType" :readonly="modePolType"></v-autocomplete>
                      <!-- <v-text-field v-model="polTypeForm.dept" :label="labels.dept" :error-messages="errors.collect('dept')" data-vv-name="dept" :data-vv-as="labels.dept" v-validate="'required|max:1'" append-icon="mdi-magnify" @click:append="getHelpList('dept')" :hint="deptDesc" persistent-hint readonly></v-text-field> -->
                    </v-flex>
                    <v-flex xs6>
                      <v-autocomplete :items="glAnCode" v-model="polTypeForm.glanCode" :label="labels.glanCode" item-text="label" item-value="value" :error-messages="errors.collect('glanCode')" data-vv-name="glanCode" :data-vv-as="labels.glanCode" v-validate="'required'" :clearable="!modePolType" :readonly="modePolType"></v-autocomplete>
                      <!-- <v-text-field v-model="polTypeForm.glanCode" :label="labels.glanCode" :error-messages="errors.collect('glanCode')" data-vv-name="glanCode" :data-vv-as="labels.glanCode" v-validate="glanCodeValidate" append-icon="mdi-magnify" @click:append="getHelpList('glanCode')" :hint="glanCodeDesc" persistent-hint readonly></v-text-field> -->
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="polTypeAppIdList" v-model="polTypeForm.polTypeAppId" :label="labels.polTypeAppId" item-text="label" item-value="value" data-vv-name="polTypeAppId" :data-vv-as="labels.polTypeAppId" :error-messages="errors.collect('polTypeAppId')" v-validate="'max:8'"></v-autocomplete>
                    </v-flex>
                    <v-flex xs6>
                      <!-- <v-autocomplete :readonly="modePolType" :items="polSchedFormList" v-model="polTypeForm.polSchedForm" :label="labels.polSchedForm" item-text="label" item-value="value" data-vv-name="polSchedForm" :data-vv-as="labels.polSchedForm" :error-messages="errors.collect('polSchedForm')" v-validate="'max:8'"></v-autocomplete> -->
                      <v-text-field :readonly="modePolType" v-model="polTypeForm.defSchedForm" :label="labels.defSchedForm" :error-messages="errors.collect('defSchedForm')" data-vv-name="defSchedForm" :data-vv-as="labels.defSchedForm" v-validate="'max:1'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="defPremHdgList" v-model="polTypeForm.defPremHdg" :label="labels.defPremHdg" item-text="label" item-value="value" data-vv-name="defPremHdg" :data-vv-as="labels.defPremHdg" :error-messages="errors.collect('defPremHdg')" v-validate="'max:1'"></v-autocomplete>
                    </v-flex>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="perOmnList" v-model="polTypeForm.perOmn" :label="labels.perOmn" item-text="label" item-value="value" data-vv-name="perOmn" :data-vv-as="labels.perOmn" :error-messages="errors.collect('perOmn')" v-validate="'max:8'"></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="comDateOpt" v-model="polTypeForm.comDateOpt" :label="labels.comDateOpt" item-text="label" item-value="value" data-vv-name="comDateOpt" :data-vv-as="labels.comDateOpt" :error-messages="errors.collect('comDateOpt')" v-validate="'max:8'"></v-autocomplete>
                    </v-flex>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="defInstalDateList" v-model="polTypeForm.defInstalDate" :label="labels.defInstalDate" item-text="label" item-value="value" data-vv-name="defInstalDate" :data-vv-as="labels.defInstalDate" :error-messages="errors.collect('defInstalDate')" @change="doPerInstal"></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <V-layout row wrap>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="polStatList" :label="labels.defPolStat" v-model="polTypeForm.defPolStat" item-text="label" item-value="value" :error-messages="errors.collect('defPolStat')" data-vv-name="defPolStat" :data-vv-as="labels.defPolStat" v-validate="'entry'">
                        <!-- <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                          <v-icon color="info" @click="getHelpList('defPolStat')" v-text="'mdi-magnify'"></v-icon>
                        </v-slide-x-reverse-transition> -->
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="polTypeGroupList" :label="labels.polTypeGroup" v-model="polTypeForm.polTypeGrp" item-text="label" item-value="value" :error-messages="errors.collect('polTypeGrp')" data-vv-name="polTypeGrp" :data-vv-as="labels.polTypeGroup" v-validate="'required'">
                      </v-autocomplete>
                    </v-flex>
                  </V-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-autocomplete :readonly="modePolType" :items="renewalListCatList" :label="labels.renListCat" v-model="polTypeForm.renListCat" item-text="label" item-value="value" :error-messages="errors.collect('renListCat')" data-vv-name="renListCat" :data-vv-as="labels.renListCat">
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.permInsd" :label="labels.permInsd" :error-messages="errors.collect('permInsd')" data-vv-name="permInsd" :data-vv-as="labels.permInsd" hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.perInstal" :label="labels.perInstal" :error-messages="errors.collect('perInstal')" data-vv-name="perInstal" :data-vv-as="labels.perInstal" hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.appPremWar" :label="labels.appPremWar" :error-messages="errors.collect('appPremWar')" data-vv-name="appPremWar" :data-vv-as="labels.appPremWar" hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.calcAgeBySysDate" :label="labels.calcAgeBySysDate" :error-messages="errors.collect('calcAgeBySysDate')" data-vv-name="calcAgeBySysDate" :data-vv-as="labels.calcAgeBySysDate" hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.protExRate" :label="labels.protExRate" :error-messages="errors.collect('protExRate')" data-vv-name="protExRate" :data-vv-as="labels.protExRate" hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.appShortTerm" :label="labels.appShortTerm" :error-messages="errors.collect('appShortTerm')" data-vv-name="appShortTerm" :data-vv-as="labels.appShortTerm" hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.perBancBill" :label="labels.permMthlyBill" :error-messages="errors.collect('perBancBill')" data-vv-name="perBancBill" :data-vv-as="labels.permMthlyBill" hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.gstApp" :label="labels.gstApp" :error-messages="errors.collect('gstApp')" data-vv-name="gstApp" :data-vv-as="labels.gstApp" hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex x12>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.insdIcUenMand" :label="labels.insdIcUenMand" :error-messages="errors.collect('insdIcUenMand')" data-vv-name="insdIcUenMand" :data-vv-as="labels.insdIcUenMand" hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
              <div>
                <v-icon>mdi-printer</v-icon><span class="headerTitle">{{labels.printing}}</span>
              </div>
          </v-expansion-panel-header>
            <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="printModeList" v-model="polTypeForm.defSchedPrtIl" :label="labels.defSchedPrtIl" item-text="label" item-value="value" data-vv-name="defSchedPrtIl" :data-vv-as="labels.defSchedPrtIl" :error-messages="errors.collect('defSchedPrtIl')"></v-autocomplete>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field :readonly="modePolType" v-model="polTypeForm.defNoSchedPrt" :label="labels.defNoSchedPrt" :error-messages="errors.collect('defNoSchedPrt')" data-vv-name="defNoSchedPrt" :data-vv-as="labels.defNoSchedPrt" v-validate="'numeric|max:10|between:0,20'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="printModeList" v-model="polTypeForm.defCiPrtIl" :label="labels.defCiPrtIl" item-text="label" item-value="value" data-vv-name="defCiPrtIl" :data-vv-as="labels.defCiPrtIl" :error-messages="errors.collect('defCiPrtIl')"></v-autocomplete>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field :readonly="modePolType" v-model="polTypeForm.defNoCiPrt" :label="labels.defNoCiPrt" :error-messages="errors.collect('defNoCiPrt')" data-vv-name="defNoCiPrt" :data-vv-as="labels.defNoCiPrt" v-validate="'numeric|max:10|between:0,20'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.prePrtedCi" :label="labels.prePrtedCi" :error-messages="errors.collect('prePrtedCi')" data-vv-name="prePrtedCi" :data-vv-as="labels.prePrtedCi" hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="printModeList" v-model="polTypeForm.defDrPrtIl" :label="labels.defDrPrtIl" item-text="label" item-value="value" data-vv-name="defDrPrtIl" :data-vv-as="labels.defDrPrtIl" :error-messages="errors.collect('defDrPrtIl')"></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="printModeList" v-model="polTypeForm.defTiPrtIl" :label="labels.defTiPrtIl" item-text="label" item-value="value" data-vv-name="defTiPrtIl" :data-vv-as="labels.defTiPrtIl" :error-messages="errors.collect('defTiPrtIl')"></v-autocomplete>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field :readonly="modePolType" v-model="polTypeForm.defNoTiPrt" :label="labels.defNoTiPrt" :error-messages="errors.collect('defNoTiPrt')" data-vv-name="defNoTiPrt" :data-vv-as="labels.defNoTiPrt" v-validate="'numeric|max:10|between:0,20'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="riskSectSchList" v-model="polTypeForm.riskSectSch" :label="labels.riskSectSch" item-text="label" item-value="value" data-vv-name="riskSectSch" :data-vv-as="labels.riskSectSch" :error-messages="errors.collect('riskSectSch')"></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.prtOrigCopy" :label="labels.prtOrigCopy" :error-messages="errors.collect('prtOrigCopy')" data-vv-name="prtOrigCopy" :data-vv-as="labels.prtOrigCopy" hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.prtRiskAsHdr" :label="labels.prtRiskAsHdr" :error-messages="errors.collect('prtRiskAsHdr')" data-vv-name="prtRiskAsHdr" :data-vv-as="labels.prtRiskAsHdr" hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.prtClass" :label="labels.prtClass" :error-messages="errors.collect('prtClass')" data-vv-name="prtClass" :data-vv-as="labels.prtClass" hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.prtAgtDet" :label="labels.prtAgtDet" :error-messages="errors.collect('prtAgtDet')" data-vv-name="prtAgtDet" :data-vv-as="labels.prtAgtDet" hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.prtOrigCopyDrcr" :label="labels.prtOrigCopyDrcr" :error-messages="errors.collect('prtOrigCopyDrcr')" data-vv-name="prtOrigCopyDrcr" :data-vv-as="labels.prtOrigCopyDrcr" hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
              <div>
                <v-icon>mdi-rotate-3d</v-icon><span class="headerTitle">{{labels.renewal}}</span>
              </div>
          </v-expansion-panel-header>
            <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.perRen" :label="labels.perRen" :error-messages="errors.collect('perRen')" data-vv-name="perRen" :data-vv-as="labels.perRen" hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.renPolNo" :label="labels.renPolNo" :error-messages="errors.collect('renPolNo')" data-vv-name="renPolNo" :data-vv-as="labels.renPolNo" hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.defCFRen" :label="labels.defCFRen" :error-messages="errors.collect('defCFRen')" data-vv-name="defCFRen" :data-vv-as="labels.defCFRen" hide-details></v-checkbox>
                    </v-flex>
                     <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.prtClse" :label="labels.prtClse" :error-messages="errors.collect('prtClse')" data-vv-name="prtClse" :data-vv-as="labels.prtClse" hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.prtPolLwrTxt" :label="labels.prtPolLwrTxt" :error-messages="errors.collect('prtPolLwrTxt')" data-vv-name="prtPolLwrTxt" :data-vv-as="labels.prtPolLwrTxt" hide-details></v-checkbox>
                    </v-flex>
                     <v-flex xs6>
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.prtRiskLwrTxt" :label="labels.prtRiskLwrTxt" :error-messages="errors.collect('prtRiskLwrTxt')" data-vv-name="prtRiskLwrTxt" :data-vv-as="labels.prtRiskLwrTxt" hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
         <v-expansion-panel-header>
              <div>
                <v-icon>mdi-repeat</v-icon><span class="headerTitle">{{labels.RI}}</span>
              </div>
         </v-expansion-panel-header>
             <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="printModeList" v-model="polTypeForm.defRiPrtIl" :label="labels.defRiPrtIl" item-text="label" item-value="value" data-vv-name="defRiPrtIl" :data-vv-as="labels.defRiPrtIl" :error-messages="errors.collect('defRiPrtIl')"></v-autocomplete>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field :readonly="modePolType" v-model="polTypeForm.defNoRiPrt" :label="labels.defNoRiPrt" :error-messages="errors.collect('defNoRiPrt')" data-vv-name="defNoRiPrt" :data-vv-as="labels.defNoRiPrt"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-text-field :readonly="modePolType" v-model="polTypeForm.defRicomm2" :label="labels.defRicomm2" :error-messages="errors.collect('defRicomm2')" data-vv-name="defRicomm2" :data-vv-as="labels.defRicomm2" v-validate="'between:0,100|decimal:6'"></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-autocomplete :readonly="modePolType" :items="defCesYrList" v-model="polTypeForm.defCesYr" :label="labels.defCesYr" item-text="label" item-value="value" data-vv-name="defCesYr" :data-vv-as="labels.renNotHdg" :error-messages="errors.collect('defCesYr')"></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 v-show="false">
                      <v-checkbox :readonly="modePolType" v-model="polTypeForm.valRidate" :label="labels.valRidate" :error-messages="errors.collect('valRidate')" data-vv-name="valRidate" :data-vv-as="labels.valRidate" hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        </v-expansion-panels>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.createdName}}</v-subheader>
                <div class="queryValue">{{polTypeForm.createdName}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.createdDate}}</v-subheader>
                <div class="queryValue">{{formatDisplayDate(polTypeForm.createdDate)}}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newPolType">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.modifiedName}}</v-subheader>
                <div class="queryValue">{{polTypeForm.modifiedName}}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.modifiedDate}}</v-subheader>
                <div class="queryValue">{{formatDisplayDate(polTypeForm.modifiedDate)}}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
            <span>Cancel</span>
            <v-icon right dark>mdi-cancel</v-icon>
          </v-btn>
          <v-btn v-if="newPolType || !modePolType" color="primary" dark @click="doSave" :loading="submitting">
            Save Policy Type
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
        <!-- helplist for dept, defPolStat, glanCode -->
        <v-dialog v-model="helplist" width="900px" persistent>
          <polNoForm-helplist v-if="polNoFormHelplist" @close="doClose" @selectPolNoForm="doAssignPolNoForm($event)"></polNoForm-helplist>
          <dept-help-list v-if="deptHelpList" @close="doClose" @selectDept="doAssignDept($event)"></dept-help-list>
          <glan-code-help-list v-if="glanCodeHelpList" @close="doClose" @selectGlanCode="doAssignGlanCode($event)"></glan-code-help-list>
          <def-polStat-help-list v-if="defPolStatHelpList" @close="doClose" @selectPolStat="doAssignPolStat($event)"></def-polStat-help-list>
        </v-dialog>
      </v-card>
    </lazy-div>
  </div>
</template>

<script>
import PolNoFormHelplist from './helplist/PolNoFormHelplist'
import { perOMN, prtIL } from '@/const/params'
import DefPolStatHelpList from './helplist/DefPolStatHelplist'
import DeptHelpList from './helplist/DeptHelplist'
import GlanCodeHelpList from './helplist/GLAnCodeHelplist'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
export default {
  data() {
    return {
      panel: [0],
      labels: {
        // general
        general: 'General',
        polType: 'Policy Type',
        polTypeDesc: 'Description',
        polNoForm: 'Policy No. Format',
        expiryTime: 'Expiry Time',
        permInsd: 'Permit Insured Person',
        defPolStat: 'Default Policy Status',
        polTypeGroup: 'Policy Type Group',
        dept: 'Department',
        glanCode: 'GL Analysis Code',
        polTypeAppId: 'Application ID',
        calcAgeBySysDate: 'Calculate Age by System Date',
        polSchedForm: 'Schedule Format',
        defPremHdg: 'Default Premium Heading',
        appPremWar: 'Apply Premium Warranty',
        perOmn: 'Permit Open Cover/ Master policy',
        protExRate: 'Protect Billing Currency Rate',
        comDateOpt: 'Commencement Date',
        appShortTerm: 'Apply Short Term Rates',
        defInstalDate: 'Default Instalment Date',
        perInstal: 'Permit Instalment',
        permMthlyBill: 'Permit Bancassurance Billing',
        insdIcUenMand: 'Insured NRIC / FIN / Passport No. or Corporate ROC / UEN Mandatory',
        defSchedForm: 'Default Schedule Format',
        renListCat: 'Renewal Listing Category',
        // printing
        printing: 'Printing Section',
        defSchedPrtIl: 'Print Schedule',
        defNoSchedPrt: 'No. of Schedule(s)',
        defCiPrtIl: 'Print CI',
        defNoCiPrt: 'No. of CI(s)',
        prePrtedCi: 'Preprinted CI Stationery',
        defDrPrtIl: 'Print Debit/ Credit Note',
        defTiPrtIl: 'Print Tax Invoice',
        defNoTiPrt: 'No. of Tax Invoice(s)',
        riskSectSch: 'Print Risk/ Section on Schedule',
        prtOrigCopy: 'Print ORIGINAL/ COPY on Schedule',
        prtRiskAsHdr: 'Print Business Class Risk as Header on Schedule',
        prtClass: 'Print Business Class on Schedule',
        prtAgtDet: 'Print Agency Information', // KIV
        prtOrigCopyDrcr: 'Print ORIGINAL/ COPY on DEBIT/ CREDIT Note',
        gstApp: 'GST Applicable',
        // renewal
        renewal: 'Renewal Section',
        perRen: 'Permit Renewal',
        renPolNo: 'Renew Policy No.',
        defCFRen: 'Default Carry Forward RI Out Transactions on Renewals',
        prtRiskLwrTxt: 'Print Risk Lower Text on Renewal Notice',
        prtPolLwrTxt: 'Print Policy Lower Text on Renewal Notice',
        prtClse: 'Print Clauses on Renewal Notice',
        // RI
        RI: 'Reinsurance Section',
        defRiPrtIl: 'Print RI Application',
        defNoRiPrt: 'No. of RI application(s)',
        defRicomm2: 'Default RI Commission 2 %',
        defCesYr: 'Default Cession Year',
        valRidate: 'Validate RI Date',
        // audit
        createdName: 'Created By',
        createdDate: 'Created Date',
        modifiedName: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      polTypeForm: {
        // general
        polType: null,
        polTypeDesc: null,
        polNoForm: null,
        supFireBlkNo: null,
        expiryTime: null,
        comitFireTot: null,
        daysToLapse: null,
        permInsd: null,
        defPolStat: null,
        polTypeGrp: null,
        dept: null,
        glanCode: null,
        polTypeAppId: null,
        calcAgeBySysDate: null,
        polSchedForm: null,
        perRetroDate: null,
        defPremHdg: null,
        appPremWar: null,
        perOmn: null,
        protExRate: null,
        comDateOpt: null,
        appShortTerm: null,
        defInstalDate: null,
        perInstal: null,
        permMthlyBill: null,
        perBancBill: null,
        insdIcUenMand: null,
        defSchedForm: null,
        renListCat: null,
        // printing
        defSchedPrtIl: null,
        defNoSchedPrt: null,
        defCiPrtIl: null,
        defNoCiPrt: null,
        prePrtedCi: null,
        defDrPrtIl: null,
        defTiPrtIl: null,
        defNoTiPrt: null,
        schedClseHdg: null,
        riskSectSch: null,
        prtOrigCopy: null,
        prtPOIExpDate: null,
        prtAgtDet: null,
        prtOrigCopyDrcr: null,
        defInsdDr: null,
        supSI: null,
        prtRiskAsHdr: 0,
        prtClass: 0,
        // renewal
        perRen: null,
        renPolNo: null,
        defCFRen: false,
        prtRiskLwrTxt: false,
        prtPolLwrTxt: false,
        prtClse: false,
        defRenPolNo: null,
        autoCalcNCB: null,
        prevPolSF: null,
        renNotHdg: null,
        prtRenPer: null,
        prtOccp: null,
        prtFinInst: null,
        prtDrv: null,
        // RI
        defRiPrtIl: null,
        defNoRiPrt: null,
        defRicomm2: null,
        defCesYr: null,
        defClmRICurr: null,
        valRidate: null,
        supAgt: null,
        supInsdName: null,
        supCedCoPrem: null,
        prtCoinsSlip: null,
        gstApp: null,
        // audit
        createdName: null,
        createdDate: null,
        modifiedName: null,
        modifiedDate: null,
        // unused
        maintPeriod: 0
      },
      departments: [],
      glAnCode: [],
      polStatList: [],
      polTypeGroupList: [],
      glanCodeValidate: 'max:2',
      helplist: false,
      polNoFormHelplist: false,
      deptHelpList: false,
      glanCodeHelpList: false,
      defPolStatHelpList: false,
      deptDesc: '',
      glanCodeDesc: '',
      defPolStatDesc: '',
      polNoFormDesc: '',
      submitting: false,
      buscls: [],
      renewalListCatList: [
        { label: '', value: null },
        { label: 'CO - Commercial', value: 'CO' },
        { label: 'MO - Motor', value: 'MO' },
        { label: 'PL - Personal', value: 'PL' }
      ]
    }
  },
  created() {},
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('polStatList')
      this.getCommonDataList('polTypeGroupList')
      this.getCommonDataList('departments')
      this.getCommonDataList('glAnCode')
      this.getCommonDataList('buscls')
      this.getMiscAcctParam()
      if (this.newPolType) {
        this.initForm()
      } else {
        await this.doFetch()
      }
    },
    initForm() {
      // general
      this.polTypeForm.polType = null
      this.polTypeForm.polTypeDesc = null
      this.polTypeForm.polNoForm = 0
      this.polTypeForm.supFireBlkNo = false
      this.polTypeForm.expiryTime = 2400
      this.polTypeForm.comitFireTot = false
      this.polTypeForm.daysToLapse = 0
      this.polTypeForm.permInsd = false
      this.polTypeForm.defPolStat = null
      this.polTypeForm.polTypeGrp = null
      this.polTypeForm.dept = null
      this.polTypeForm.glanCode = null
      this.polTypeForm.polTypeAppId = 'MI'
      this.polTypeForm.calcAgeBySysDate = true
      this.polTypeForm.polSchedForm = 'MI'
      this.polTypeForm.perRetroDate = false
      this.polTypeForm.defPremHdg = 'S'
      this.polTypeForm.appPremWar = false
      this.polTypeForm.perOmn = 'N'
      this.polTypeForm.protExRate = false
      this.polTypeForm.comDateOpt = 'M'
      this.polTypeForm.appShortTerm = false
      this.polTypeForm.defInstalDate = 'N'
      this.polTypeForm.perInstal = false
      this.polTypeForm.perBancBill = false
      this.polTypeForm.insdIcUenMand = true
      this.polTypeForm.gstApp = false
      this.polTypeForm.defSchedForm = ''
      this.polTypeForm.renListCat = null
      // printing
      this.polTypeForm.defSchedPrtIl = 'L'
      this.polTypeForm.defNoSchedPrt = 0
      this.polTypeForm.defCiPrtIl = 'L'
      this.polTypeForm.defNoCiPrt = 0
      this.polTypeForm.prePrtedCi = false
      this.polTypeForm.defDrPrtIl = 'L'
      this.polTypeForm.defTiPrtIl = 'L'
      this.polTypeForm.defNoTiPrt = 0
      this.polTypeForm.schedClseHdg = null
      this.polTypeForm.riskSectSch = 'Risk'
      this.polTypeForm.prtOrigCopy = true
      this.polTypeForm.prtPOIExpDate = false
      this.polTypeForm.prtAgtDet = false
      this.polTypeForm.prtOrigCopyDrcr = true
      this.polTypeForm.defInsdDr = false
      this.polTypeForm.supSI = false
      this.polTypeForm.prtClass = false
      this.polTypeForm.prtRiskAsHdr = false
      // renewal
      this.polTypeForm.perRen = false
      this.polTypeForm.renPolNo = false
      this.polTypeForm.defCFRen = false
      this.polTypeForm.prtRiskLwrTxt = false
      this.polTypeForm.prtPolLwrTxt = false
      this.polTypeForm.prtClse = false
      this.polTypeForm.defRenPolNo = 0
      this.polTypeForm.autoCalcNCB = false
      this.polTypeForm.prevPolSF = false
      this.polTypeForm.renNotHdg = false
      this.polTypeForm.prtRenPer = false
      this.polTypeForm.prtPolLwrTxt = false
      this.polTypeForm.prtRiskLwrTxt = false
      this.polTypeForm.prtOccp = false
      this.polTypeForm.prtFinInst = false
      this.polTypeForm.prtDrv = false
      // RI
      this.polTypeForm.defRiPrtIl = 'I'
      this.polTypeForm.defNoRiPrt = 0
      this.polTypeForm.defRicomm2 = 0
      this.polTypeForm.defCesYr = true
      this.polTypeForm.defClmRICurr = false
      this.polTypeForm.valRidate = true
      this.polTypeForm.supAgt = false
      this.polTypeForm.supInsdName = false
      this.polTypeForm.supCedCoPrem = false
      this.polTypeForm.prtCoinsSlip = false
      // audit
      this.polTypeForm.createdName = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.polTypeForm.createdDate = new Date()
    },
    async doFetch() {
      const apiURI = this.menu.getPolType
      if (apiURI) {
        try {
          const expand = {
            polType: this.polType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // general
            this.polTypeForm.polType = data.polType.polType
            this.polTypeForm.polTypeDesc = data.polType.polTypeDesc
            this.polTypeForm.polNoForm = data.polType.polNoForm
            this.polNoFormDesc = data.polType.polNoFormDesc
            this.polTypeForm.supFireBlkNo = data.polType.supFireBlkNo
            this.polTypeForm.expiryTime = data.polType.expiryTime
            this.polTypeForm.comitFireTot = data.polType.comitFireTot
            this.polTypeForm.daysToLapse = data.polType.daysToLapse
            this.polTypeForm.permInsd = data.polType.permInsd
            this.polTypeForm.defPolStat = data.polType.defPolStat
            this.polTypeForm.polTypeGrp = data.polType.polTypeGrp
            this.defPolStatDesc = data.polType.polStatDesc
            this.polTypeForm.dept = data.polType.dept
            this.deptDesc = data.polType.deptDesc
            this.polTypeForm.glanCode = data.polType.glanCode
            this.doGlanCode()
            this.glanCodeDesc = data.polType.glanCodeDesc
            this.polTypeForm.polTypeAppId = data.polType.polTypeAppId
            this.polTypeForm.calcAgeBySysDate = data.polType.calcAgeBySysDate
            this.polTypeForm.polSchedForm = data.polType.polSchedForm
            this.polTypeForm.perRetroDate = data.polType.perRetroDate
            this.polTypeForm.defPremHdg = data.polType.defPremHdg
            this.polTypeForm.appPremWar = data.polType.appPremWar
            this.polTypeForm.perOmn = data.polType.perOmn
            this.polTypeForm.protExRate = data.polType.protExRate
            this.polTypeForm.comDateOpt = data.polType.comDateOpt
            this.polTypeForm.appShortTerm = data.polType.appShortTerm
            this.polTypeForm.defInstalDate = data.polType.defInstalDate
            this.polTypeForm.perInstal = data.polType.perInstal
            this.polTypeForm.perBancBill = data.polType.perBancBill
            this.polTypeForm.insdIcUenMand = data.polType.insdIcUenMand
            this.polTypeForm.defPolStat = data.polType.defPolStat
            this.polTypeForm.defSchedForm = data.polType.defSchedForm
            this.polTypeForm.renListCat = data.polType.renListCat
            // printing
            this.polTypeForm.defSchedPrtIl = data.polType.defSchedPrtIl
            this.polTypeForm.defNoSchedPrt = data.polType.defNoSchedPrt
            this.polTypeForm.defCiPrtIl = data.polType.defCiPrtIl
            this.polTypeForm.defNoCiPrt = data.polType.defNoCiPrt
            this.polTypeForm.prePrtedCi = data.polType.prePrtedCi
            this.polTypeForm.defDrPrtIl = data.polType.defDrPrtIl
            this.polTypeForm.defTiPrtIl = data.polType.defTiPrtIl
            this.polTypeForm.defNoTiPrt = data.polType.defNoTiPrt
            this.polTypeForm.schedClseHdg = data.polType.schedClseHdg
            this.polTypeForm.riskSectSch = data.polType.riskSectSch
            this.polTypeForm.prtOrigCopy = data.polType.prtOrigCopy
            this.polTypeForm.prtPOIExpDate = data.polType.prtPOIExpDate
            this.polTypeForm.prtAgtDet = data.polType.prtAgtDet
            this.polTypeForm.prtOrigCopyDrcr = data.polType.prtOrigCopyDrcr
            this.polTypeForm.defInsdDr = data.polType.defInsdDr
            this.polTypeForm.supSI = data.polType.supSI
            this.polTypeForm.prtClass = data.polType.prtClass
            this.polTypeForm.prtRiskAsHdr = data.polType.prtRiskAsHdr
            // renewal
            this.polTypeForm.perRen = data.polType.perRen
            this.polTypeForm.renPolNo = data.polType.renPolNo
            this.polTypeForm.defRenPolNo = data.polType.defRenPolNo
            this.polTypeForm.autoCalcNCB = data.polType.autoCalcNCB
            this.polTypeForm.prevPolSF = data.polType.prevPolSF
            this.polTypeForm.renNotHdg = data.polType.renNotHdg
            this.polTypeForm.prtRenPer = data.polType.prtRenPer
            this.polTypeForm.prtPolLwrTxt = data.polType.prtPolLwrTxt
            this.polTypeForm.prtRiskLwrTxt = data.polType.prtRiskLwrTxt
            this.polTypeForm.prtOccp = data.polType.prtOccp
            this.polTypeForm.prtFinInst = data.polType.prtFinInst
            this.polTypeForm.prtDrv = data.polType.prtDrv
            this.polTypeForm.gstApp = data.polType.gstApp
            // RI
            this.polTypeForm.defRiPrtIl = data.polType.defRiPrtIl
            this.polTypeForm.defNoRiPrt = data.polType.defNoRiPrt
            this.polTypeForm.defRicomm2 = data.polType.defRicomm2
            this.polTypeForm.defCesYr = data.polType.defCesYr
            this.polTypeForm.defClmRICurr = data.polType.defClmRICurr
            this.polTypeForm.defCFRen = data.polType.defCfRen
            this.polTypeForm.prtRiskLwrTxt = data.polType.prtRiskLwrTxt
            this.polTypeForm.prtPolLwrTxt = data.polType.prtPolLwrTxt
            this.polTypeForm.prtClse = data.polType.prtClse
            this.polTypeForm.valRidate = data.polType.valRidate
            this.polTypeForm.supAgt = data.polType.supAgt
            this.polTypeForm.supInsdName = data.polType.supInsdName
            this.polTypeForm.supCedCoPrem = data.polType.supCedCoPrem
            this.polTypeForm.prtCoinsSlip = data.polType.prtCoinsSlip
            // audit
            this.polTypeForm.createdName = data.createdBy
            this.polTypeForm.createdDate = data.createdDate
            this.polTypeForm.modifiedName = data.modifiedBy
            this.polTypeForm.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getMiscAcctParam() {
      const apiURI = this.menu.getMiscAcctParam
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          if (data.miscAcctParam.glSys === 2) {
            this.glanCodeValidate += '|required'
          }
        }
      }
    },
    getHelpList(fieldname) {
      if (!this.modePolType) {
        this.helplist = true
        if (fieldname === 'dept') {
          this.deptHelpList = true
        } else if (fieldname === 'polNoForm') {
          this.polNoFormHelplist = true
        } else if (fieldname === 'glanCode') {
          this.glanCodeHelpList = true
        } else if (fieldname === 'defPolStat') {
          this.defPolStatHelpList = true
        }
      }
    },
    doDefPolStat() {
      this.$validator.validate('defPolStat').then((result) => {
        if (result) {
          const apiURI = this.menu.getPolStat
          if (apiURI) {
            const expand = {
              polStat: this.polTypeForm.defPolStat
            }
            this.$http
              .get(expandURI(apiURI, expand))
              .then((result) => {
                const { data } = result.data
                if (data) {
                  this.defPolStatDesc = data.polStat.polStatDesc
                }
              })
              .catch((err) => {
                this.polTypeForm.defPolStat = ''
                this.defPolStatDesc = ''
                const { data } = err.response
                if (data) {
                  // this.message(data)
                  // this.fieldMessage(data)
                  this.notify(data)
                }
              })
          }
        } else {
          this.defPolStatDesc = ''
        }
      })
    },
    doAssignPolStat(polStatObj) {
      this.$validator.errors.remove('defPolStat')
      this.polTypeForm.defPolStat = polStatObj.polStat
      this.defPolStatDesc = polStatObj.polStatDesc
    },
    doDept() {
      this.$validator.validate('dept').then((result) => {
        if (result) {
          const apiURI = this.menu.getDept
          if (apiURI) {
            const expand = {
              dept: this.polTypeForm.dept
            }
            this.$http
              .get(expandURI(apiURI, expand))
              .then((result) => {
                const { data } = result.data
                if (data) {
                  this.deptDesc = data.dept.deptDesc
                }
              })
              .catch((err) => {
                this.polTypeForm.dept = ''
                this.deptDesc = ''
                const { data } = err.response
                if (data) {
                  // this.message(data)
                  // this.fieldMessage(data)
                  this.notify(data)
                }
              })
          }
        } else {
          this.deptDesc = ''
        }
      })
    },
    doAssignDept(deptObj) {
      this.$validator.errors.remove('dept')
      this.polTypeForm.dept = deptObj.dept
      this.deptDesc = deptObj.deptDesc
    },
    doGlanCode() {
      const apiURI = this.menu.getGlanCode
      if (apiURI) {
        const expand = {
          glanCode: this.polTypeForm.glanCode
        }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.glanCodeDesc = data.glanCode.glanDesc
            }
          })
          .catch((err) => {
            this.polTypeForm.glanCode = ''
            this.glanCodeDesc = ''
          })
      }
    },
    doAssignGlanCode(glanCodeObj) {
      this.$validator.errors.remove('glanCode')
      this.polTypeForm.glanCode = glanCodeObj.glAnCode
      this.glanCodeDesc = glanCodeObj.glAnCodeDesc
    },
    doPolNoForm() {
      if (parseInt(this.polTypeForm.polNoForm) === 0) {
        this.$validator.errors.remove('polNoForm')
        this.polNoFormDesc = ''
      } else if (parseInt(this.polTypeForm.polNoForm) !== 0) {
        this.errors.add({
          field: 'polNoForm',
          msg: 'Only 0 is accepted for manual entry. Please click on the "Search" button for more Policy No. Format list.'
        })
      } else {
        this.$validator.validate('polNoForm').then((result) => {
          if (result) {
            const apiURI = this.menu.getPolNoFactor
            if (apiURI) {
              const expand = {
                formId: this.polTypeForm.polNoForm
              }
              this.$http
                .get(expandURI(apiURI, expand))
                .then((result) => {
                  const { data } = result.data
                  if (data) {
                    this.polNoFormDesc = data.polNoFactor.formDesc
                  }
                })
                .catch((err) => {
                  this.polTypeForm.polNoForm = ''
                  this.polNoFormDesc = ''
                  const { data } = err.response
                  if (data) {
                    // this.message(data)
                    // this.fieldMessage(data)
                    this.notify(data)
                  }
                })
            }
          } else {
            this.polNoFormDesc = ''
          }
        })
      }
    },
    doAssignPolNoForm(polNoFormObj) {
      this.$validator.errors.remove('polNoForm')
      this.polTypeForm.polNoForm = polNoFormObj.formId
      this.polNoFormDesc = polNoFormObj.formDesc
    },
    doClose() {
      this.helplist = false
      setTimeout(() => {
        this.polNoFormHelplist = false
        this.glanCodeHelpList = false
        this.deptHelpList = false
      }, 500)
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doGlanCode()
          if (!this.customValidation()) {
            return
          }
          this.submitting = true
          const config = {
            method: this.newPolType ? 'post' : 'put',
            url: this.newPolType ? this.menu.createPolType : this.menu.updatePolType,
            data: this.polTypeForm
          }
          if (config.url) {
            this.$http
              .request(config)
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.$router.push({ name: 'polTypeList' })
              })
              .catch((err) => {
                this.submitting = false
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doPerInstal() {
      const defInstalDate = this.polTypeForm.defInstalDate
      if (defInstalDate === 'C' || defInstalDate === 'T') {
        this.polTypeForm.perInstal = true
      } else if (defInstalDate === 'N') {
        this.polTypeForm.perInstal = false
      }
    },
    customValidation() {
      const polTypeForm = this.polTypeForm
      if (polTypeForm.defInstalDate === 'C' || polTypeForm.defInstalDate === 'T') {
        if (!polTypeForm.perInstal) {
          this.$toast.error("Must permit instalment if Default Instalment is 'C' or 'T'.")
          return false
        }
      }
      return true
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    doBusCls() {
      this.$router.push({ name: 'polTypeCls', params: { polType: this.polTypeForm.polType, polTypeDesc: this.polTypeForm.polTypeDesc } })
    },
    doCancel() {
      this.$router.push({ name: 'polTypeList' })
    }
  },
  watch: {},
  computed: {
    polTypeAppIdList() {
      return [
        { label: 'CA - Cargo', value: 'CA' },
        { label: 'HE - Health', value: 'HE' },
        { label: 'HU - Hull', value: 'HU' },
        { label: 'FI - Fire', value: 'FI' },
        { label: 'MD - Maid', value: 'MD' },
        { label: 'MO - Motor', value: 'MO' },
        { label: 'PA - Personal Accident', value: 'PA' },
        { label: 'MI - Miscellaneous', value: 'MI' },
        { label: 'TR - Travel', value: 'TR' }
      ]
    },
    polSchedFormList() {
      return [
        { label: 'CA - Cargo', value: 'CA' },
        { label: 'HE - Health', value: 'HE' },
        { label: 'HU - Hull', value: 'HU' },
        { label: 'FI - Fire', value: 'FI' },
        { label: 'MO - Motor', value: 'MO' },
        { label: 'PA - Personal Accident', value: 'PA' },
        { label: 'MI - Miscellaneous', value: 'MI' }
      ]
    },
    defPremHdgList() {
      return [
        { label: 'S - Standard', value: 'S' },
        { label: 'M - Minimum', value: 'M' },
        { label: 'A - Arranged', value: 'A' },
        { label: 'R - Each Risk', value: 'R' },
        { label: 'D - Deposit', value: 'D' },
        { label: 'P - Project', value: 'P' },
        { label: 'F - Free Insurance', value: 'F' },
        { label: '1 - Takaful As Arranged', value: '1' },
        { label: '2 - Takaful Free Insurance', value: '2' }
      ]
    },
    perOmnList() {
      let result = []
      Object.keys(perOMN).forEach(function (key) {
        const status = perOMN[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    comDateOpt() {
      return [
        { label: 'M - Mandatory', value: 'M' },
        { label: 'O - Optional', value: 'O' },
        { label: 'N - Not Allowed', value: 'N' }
      ]
    },
    defInstalDateList() {
      return [
        { label: 'N - Not Applicable', value: 'N' },
        { label: 'C - Commencement Date', value: 'C' },
        { label: 'T - Transaction', value: 'T' }
      ]
    },
    printModeList() {
      let result = []
      Object.keys(prtIL).forEach(function (key) {
        const status = prtIL[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    riskSectSchList() {
      return [
        { label: 'Risk', value: 'Risk' },
        { label: 'Section', value: 'Section' }
      ]
    },
    renNotHdgList() {
      return [
        { label: 'Renewal Certificate', value: false },
        { label: 'Schedule', value: true }
      ]
    },
    defCesYrList() {
      return [
        { label: 'Underwriting', value: true },
        { label: 'Transaction', value: false }
      ]
    },
    defClmRICurrList() {
      return [
        { label: 'Foreign', value: true },
        { label: 'Local', value: false }
      ]
    },
    newPolType() {
      return this.polType === 'new'
    },
    menu() {
      return this.$store.state.polTypeParam.menu
    },
    modePolType() {
      return this.$route.params.modeQuery
    }
  },
  components: {
    PolNoFormHelplist,
    DeptHelpList,
    GlanCodeHelpList,
    DefPolStatHelpList
  },
  props: ['polType', 'polTypeDesc'],
  mixins: [commonAjaxMixin, MessageMixin]
}
</script>

<style>
</style>
